import useVarParam from "./use-var-param";
import { getEnabledLanguage } from "mock-data/translation/languages";


const useEffectiveLanguage = () => {
    const appParams = useVarParam(),
          params = appParams.get(),
          me = params.me;

    const override = params.translationLanguageOverride;
    const translationLanguages = params.translationLanguages || [];
    const defaultLanguage = me && getEnabledLanguage(me.language_slug, translationLanguages) ? me.language_slug : "en";
    const language = override && getEnabledLanguage(override, translationLanguages) ? override : defaultLanguage;

    return {
        language,
        override,
        defaultLanguage,
        overridden   : language === override,
        sourceLang   : params.defaultLanguage || "de"
    };
};

export default useEffectiveLanguage;
